import { useEffect } from "react";

import { useUser } from "@shared/features/auth/hooks/useUser";
import { storage } from "@shared/utils/storage";

import { useOrganizationStore } from "../stores/useOrganizationStore";
import { AccessPolicyStatus } from "../../../../api/src/access-policy/constants/access-policy-status.enum";
import { AccessPolicyResource } from "../../../../api/src/access-policy/constants/access-policy-resource.enum";

export const useOrganizationSwitcher = () => {
  const user = useUser();
  const organizationStore = useOrganizationStore();

  const fetch = () => {
    const lastCurrentOrganizationId = storage.local.get(
      "organisationSwitcher.currentOrganizationId"
    );

    switch (user.userType) {
      case "organization":
        organizationStore.updateOrganizations([
          {
            ...user.userData,
          },
        ]);
        organizationStore.selectCurrentOrganization(user.userData.id);
        break;

      default:
        organizationStore.updateOrganizations(
          user.userData.organizations ?? []
        );

        organizationStore.updatePendingOrganizations(
          user.hasAccessTo
            .filter(
              (x) =>
                x.resource === AccessPolicyResource.ORGANIZATION &&
                x.status === AccessPolicyStatus.PENDING
            )
            .map((x) => useUser(x.from))
            .filter(Boolean)
        );

        if (
          lastCurrentOrganizationId &&
          user.userData.organizations?.find(
            (x) => x.id === lastCurrentOrganizationId
          )
        ) {
          organizationStore.selectCurrentOrganization(
            lastCurrentOrganizationId
          );
        } else if (user.userData.organizations?.[0]) {
          organizationStore.selectCurrentOrganization(
            user.userData.organizations[0].id
          );
        }
    }
  };

  useEffect(() => {
    if (user && !organizationStore.initialized) {
      fetch();
      organizationStore.initialize();
    }
  }, [user]);

  useEffect(() => {
    if (organizationStore.currentOrganization) {
      storage.local.set(
        "organisationSwitcher.currentOrganizationId",
        organizationStore.currentOrganization.id
      );
    }
  }, [organizationStore.currentOrganization]);

  return { ...organizationStore, refresh: fetch };
};
